import React from 'react';
import {connect} from 'react-redux';

import {ComponentsList, TrustedComponents} from './ComponentsList';


import {collapseSections, toggleSecurityViewMode} from '../../../state/actions/app'
import {setElementToExclude, setExclusionToRemove} from '../../../state/actions/exclusions'

import SecuritySummary from './Summary'
import ComponentsGroupedByCVE, { ExcludedComponentsGroupedByCVE } from './componentsGroupedByCVE';

const mapStateAsProps = state => ({
	readonly: state.projectInfo.projectInfo.readonly,
	privateMode: state.projectInfo.urlParams.mode,
	isSafeVersionAllowed: state.projectInfo.titleState.hasSafeVersion,
	summary: state.projectInfo.report.security,
	autofixPullRequests: state.projectInfo.report.autofixPullRequests,
	exclusions: state.projectInfo.exclusions,
	isLatest: state.projectInfo.isLatestReport,
	isSysAdmin: state.projectInfo.titleState.isUserAdmin,
	hasSecureCodeWarriorFeature: state.projectInfo.titleState.hasSecureCodeWarriorFeature,
	collapsed: state.summariesState.security,
	projectInfo: state.projectInfo,
	security: state.projectInfo.security,
	toggledLanguages: state.languagesFilter.toggledLanguages,
	viewModes: state.viewModeState
})

const mapDispatchAsProps = dispatch => ({
	newMitigations : (reason,newMitigation,isGlobalExclusionAvailable)=>dispatch(setElementToExclude(reason,newMitigation,isGlobalExclusionAvailable)),
	collapse: (current)=>dispatch(collapseSections("security", current)),
	removeMitigations : (advice,isGlobalExclusionAvailable)=>dispatch(setExclusionToRemove(advice,isGlobalExclusionAvailable)),
	toggleSecurityViewMode: () => dispatch(toggleSecurityViewMode())
})







class Security extends React.Component{
	constructor(props){
		super(props)
		this.state={
			securityAction: false,
			defectAction: false,
			ready:false,
			advisoriesSCWContent:{
			},
			cards: [],
			filters: {critical: true, high:true, medium: true, low: true, others: false},
		}
		this.advicesData={};
		this.advisories = {}
		
		this.processedCards = {}
		this.preview = null
	}
	

	preprocess(){

		const section = this.props.security.section.standard
		this.setState({ready:true,showFilters: section.showFilters})
	}


	filterAdvisories(which){
		const newState=!this.state.filters[which];
		if(newState){
			window.$(`div[data-severity=${which}]`).show()
		}
		else{
			window.$(`div[data-severity=${which}]`).hide()
		}
		for(const wrapper of [...window.$(`.dependency-inner`)]){
			if([...window.$(wrapper).children()].filter(c=>window.$(c).css("display")!=="none").length===1){
				window.$(wrapper).parent().hide()
				window.$(wrapper).parent().next().hide()
			}
			else{
				window.$(wrapper).parent().show()
				window.$(wrapper).parent().next().show()
			}
		}

		this.setState({filters:{...this.state.filters, [which]: newState}})

	}


	componentDidMount(){
		this.preprocess()
	}


	

	


	render(){
		if(!this.state.ready) return ""
		const groupAdvisoryByCVE = this.props.viewModes.groupAdvisoryByCVE
		const Filters = ()=>(
			<React.Fragment>
				<div id="filter-critical" className="btn security-filter">
					<div className="custom-control custom-switch">
						<input data-trigger="focus" type="checkbox" className="custom-control-input" id="switch-filter-critical" onChange={()=>this.filterAdvisories("critical")} defaultChecked={this.state.filters.critical}/>
						<label className="custom-control-label" htmlFor="switch-filter-critical"><span className="d-block d-md-none d-lg-block">CRITICAL</span><span className="d-none d-md-block d-lg-none">CRIT</span></label>
					</div>
				</div>
				<div id="filter-high" className="btn security-filter">
					<div className="custom-control custom-switch">
						<input data-trigger="focus" type="checkbox" className="custom-control-input" id="switch-filter-high" onChange={()=>this.filterAdvisories("high")} defaultChecked={this.state.filters.high}/>
						<label className="custom-control-label" htmlFor="switch-filter-high">HIGH</label>
					</div>
				</div>
				<div id="filter-medium" className="btn security-filter">
					<div className="custom-control custom-switch">
						<input data-trigger="focus" type="checkbox" className="custom-control-input" id="switch-filter-medium" onChange={()=>this.filterAdvisories("medium")} defaultChecked={this.state.filters.medium}/>
						<label className="custom-control-label" htmlFor="switch-filter-medium"><span className="d-block d-md-none d-lg-block">MEDIUM</span><span className="d-none d-md-block d-lg-none">MED</span></label>
					</div>
				</div>
				<div id="filter-low" className="btn security-filter">
					<div className="custom-control custom-switch">
						<input data-trigger="focus" type="checkbox" className="custom-control-input" id="switch-filter-low" onChange={()=>this.filterAdvisories("low")} defaultChecked={this.state.filters.low}/>
						<label className="custom-control-label" htmlFor="switch-filter-low">LOW</label>
					</div>
				</div>
				<div id="filter-others" className="btn security-filter">
					<div className="custom-control custom-switch">
						<input data-trigger="focus" type="checkbox" className="custom-control-input" id="switch-filter-others" onChange={()=>this.filterAdvisories("others")} defaultChecked={this.state.filters.others}/>
						<label className="custom-control-label" htmlFor="switch-filter-others"><span className="d-block d-md-none d-lg-block">OTHER</span><span className="d-none d-md-block d-lg-none">OTH</span></label>
					</div>
				</div>
				
				
				
			</React.Fragment>
		)

		const SecurityComponents = ()=>(<ComponentsList toggledLanguages={this.props.toggledLanguages} forExclusions={false} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} advicesData={this.advicesData} autofixPullRequests={this.props.autofixPullRequests}/>)
		const SecurityExcludedComponents = ()=>(<ComponentsList toggledLanguages={this.props.toggledLanguages} forExclusions={true} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} advicesData={this.advicesData} autofixPullRequests={this.props.autofixPullRequests}/>)
		const SecurityTrusted = () => (<TrustedComponents toggledLanguages={this.props.toggledLanguages} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} />)

		const {display}=this.props;
		return(

			display?
				<React.Fragment>
					{!this.props.security.security.fullyExcluded || this.props.collapsed?
						<div className="row" id="defects-row">
							<div className="pb-3 col-lg-12">&nbsp;</div>
							<div className="col-lg-12 row pr-0 pb-2">
								<div className="col-md-5">
									<div>
										<h3 className="report-header mb-0 pb-0 d-inline" ><span name="dependencies-assessment"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY ASSESSMENT</span> </h3><i tabIndex={0} className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)} onKeyUp={(e)=>{if(e.key.toLocaleLowerCase()=="enter") this.props.collapse(this.props.collapsed)}}></i>
										{!this.props.collapsed ? <span className="ml-2 pt-0 btn btn-link pointer" onClick={() => {
											this.props.toggleSecurityViewMode()
										}}>{groupAdvisoryByCVE ? "(View by component)": "(View by vulnerability)"}</span>
										:null}
									</div>
								</div>
								<div className="col-md-7 text-right pr-0">
									{!this.props.collapsed && this.state.showFilters?
										<Filters />:
										""
									}
								</div>
								
							</div>
							{
								this.props.collapsed?
									<SecuritySummary {...this.props} />:
									!groupAdvisoryByCVE?
									<SecurityComponents />: <ComponentsGroupedByCVE display={this.state.groupAdvisoryByCVE} advisoriesMappedByCve={this.props.security.advisoriesMappedByCve} parentProps={this.props} filters={this.state.filters} newMitigations={this.props.newMitigations}/>
							}
						</div>
						:
						null
					}
					{!this.props.collapsed && this.props.security.security.hasExclusions?
						!groupAdvisoryByCVE ? <div className="row mt-5 mb-5" id="mitigations-row">
								<div className="col-lg-8">
								
									<h3 className="report-header mb-0 pb-0 d-inline" >{this.collapsed && this.props.security.security.hasExclusions}<span name="security-exclusions"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY EXCLUSIONS</span> </h3>
									{this.props.security.security.fullyExcluded?<i className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)}></i>:null}
								</div>
								<SecurityExcludedComponents />
								<SecurityTrusted />
							</div>
							: <div className='row mt-5 mb-5' id="mitigations-row">
								<div className="w-100 mb-3 ml-3">
									<h3 className="report-header mb-0 pb-0 d-inline" >{this.collapsed && this.props.security.security.hasExclusions}<span name="security-exclusions"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY EXCLUSIONS</span> </h3>
									{this.props.security.security.fullyExcluded?<i className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)}></i>:null}
								</div>
								<ExcludedComponentsGroupedByCVE display={this.state.groupAdvisoryByCVE} advisoriesMappedByCve={this.props.security.advisoriesMappedByCve} parentProps={this.props} filters={this.state.filters} newMitigations={this.props.newMitigations}/>
							</div>
						:
						null
					}
				</React.Fragment>
				
			:null
		)
	}
}

export default connect(mapStateAsProps,mapDispatchAsProps)(Security);